module.exports = __webpack_public_path__ + "static/logo-f0dcbd235df55bacf8453f4654379629.png";